<template>
  <div v-if="templateConfig.theme !== 'Operator-Template'">
    <v-card class="templateCard elevation-5">
      <v-card-text>
        <v-layout justify-space-between align-start wrap>
          <CardHeader
            :initialProductName="
              SubscribeFlowDetails.subscriptionProductDetails &&
              SubscribeFlowDetails.subscriptionProductDetails.initialProductName
            "
            :initialProductPrice="
              SubscribeFlowDetails.merchantOperatorDisclaimer &&
              SubscribeFlowDetails.merchantOperatorDisclaimer.price
            "
            :currency="
              SubscribeFlowDetails.merchantOperatorDisclaimer &&
              SubscribeFlowDetails.merchantOperatorDisclaimer.currency
            "
          />
          <v-flex
            :xs10="templateConfig.theme === 'Template-A'"
            :md9="templateConfig.theme === 'Template-A'"
            :xs12="templateConfig.theme === 'Template-B'"
          >
            <div style="overflow: hidden">
              <transition mode="out-in">
                <KeepAlive :max="2">
                  <Component :is="SubscribeFlowDetails.component" />
                </KeepAlive>
              </transition>
            </div>
          </v-flex>
          <!-- Vertical stepper start -->
          <v-flex
            :xs2="templateConfig.theme === 'Template-A'"
            :md3="templateConfig.theme === 'Template-A'"
            v-if="
              templateConfig.theme === 'Template-A' ||
              templateConfig.theme === 'Template-B'
            "
          >
            <CustomStepper
              :model="SubscribeFlowDetails.step"
              :steps="steps"
              :isVertical="templateConfig.theme === 'Template-A'"
            />
            <PrimaryDisclaimer
              class="primaryDisc"
              v-if="templateConfig.theme === 'Template-B'"
            >
              <div v-html="primaryDisclaimerText"></div>
              <div v-html="enableBackDatedDisclaimerText"></div>
              <div v-html="moCancelationDisclaimerText"></div>
              <div v-html="generalDisclaimerText"></div>
            </PrimaryDisclaimer>
            <template
              v-if="
                !merchantConfig.configs.HideTermsAndConditions &&
                templateConfig.theme === 'Template-B'
              "
            >
              <div class="cardFooter">
                <Terms />
              </div>
            </template>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <PrimaryDisclaimer
      class="primaryDisc"
      v-if="templateConfig.theme === 'Template-A'"
    >
      <div v-html="primaryDisclaimerText"></div>
      <div v-html="enableBackDatedDisclaimerText"></div>
      <div v-html="moCancelationDisclaimerText"></div>
      <div v-html="generalDisclaimerText"></div>
    </PrimaryDisclaimer>
  </div>

  <!-- Embedded Template-->
  <div
    v-else-if="templateConfig.theme === 'Operator-Template'"
    class="text-center"
  >
    <!-- To prevent re-initialize init step in case of go back from "already took" step -->
    <KeepAlive :max="4">
      <Component :is="SubscribeFlowDetails.component" />
    </KeepAlive>
  </div>
</template>

<script>
//1.General imports.
import { mapState, mapMutations } from 'vuex';
import Terms from '../Shared/components/Terms/terms.vue';

//2.shared comp. imports.
import CardHeader from '../Shared/components/CardHeader.vue';
import CustomStepper from '../Shared/components/custom-stepper.vue';
import PrimaryDisclaimer from '../Shared/components/Disclaimer.vue';
import ExpiredSession from '../Shared/components/ExpiredSession.vue';

//3. HeaderEnrichement flow components imports.
import HEInit from './stepper-content/HE-init.vue';
import HEPincode from './stepper-content/HE-pincode.vue';
import HESuccess from '../Subscription-flow/stepper-content/Sub-success.vue';
import HEFailure from '../Subscription-flow/stepper-content/Sub-failure.vue';
import HEConfirmTrial from './stepper-content/HE-confirm-trial.vue';

export default {
  computed: {
    ...mapState(['merchantConfig', 'templateConfig', 'SubscribeFlowDetails']),
    primaryDisclaimerText() {
      let availableData = {
        productName:
          this.SubscribeFlowDetails.subscriptionProductDetails
            .initialProductName,
        price: this.SubscribeFlowDetails.merchantOperatorDisclaimer.price,
        currency: this.SubscribeFlowDetails.merchantOperatorDisclaimer.currency,
        frequency:
          this.SubscribeFlowDetails.subscriptionProductDetails.frequency,
        cancelKeyword:
          this.SubscribeFlowDetails.merchantOperatorDisclaimer
            .cancelationKeyword,
        cancelShortCode:
          this.SubscribeFlowDetails.merchantOperatorDisclaimer
            .cancelationShortCode,
      };
      switch (this.SubscribeFlowDetails.component) {
        case 'HEInit':
          //Needs $replacePlaceholders plugin function for
          //[productName, price, currency, frequency, cancelKeyword, cancelShortCode] placeholders.
          return this.$replacePlaceholders(
            this.merchantConfig.texts.initPrimaryDisclaimer,
            availableData
          );
        case 'HEPincode':
          //Needs $replacePlaceholders plugin function for
          //[productName, price, currency, frequency, cancelKeyword, cancelShortCode] placeholders.
          return this.$replacePlaceholders(
            this.merchantConfig.texts.pinCodePrimaryDislcaimer,
            availableData
          );
        case 'HESuccess':
          //Needs $replacePlaceholders plugin function for
          //[productName, price, currency, frequency, cancelKeyword, cancelShortCode] placeholders.
          return this.$replacePlaceholders(
            this.merchantConfig.texts.successPrimaryDisclaimer,
            availableData
          );
        case 'HEFailure': //double check if it exist and need place holders or not.
          //No need for $replacePlaceholders plugin function.
          return this.merchantConfig.texts.failurePrimaryDisclaimer;
        case 'HEConfirmTrial':
          //Needs $replacePlaceholders plugin function for
          //[productName, price, currency, frequency] placeholders.
          return this.$replacePlaceholders(
            this.merchantConfig.texts.afterTrialPrimaryDisclaimer,
            availableData
          );
        default:
          return '';
      }
    },
    enableBackDatedDisclaimerText() {
      //No need for $replacePlaceholders plugin function.
      return this.SubscribeFlowDetails.merchantOperatorDisclaimer
        .enableBackDatedCollection
        ? this.merchantConfig.texts.enableBackDatedDisclaimer
        : '';
    },
    moCancelationDisclaimerText() {
      //Needs $replacePlaceholders plugin function for
      //[cancelKeyword, cancelShortCode] placeholders.

      if (Object.keys(this.SubscribeFlowDetails.selectedOperator.disclaimerParams).length === 0) {
        return "";
      }

      return this.$replacePlaceholders(
        this.merchantConfig.texts.moCancelationDisclaimer,
        {
          cancelShortCode:
            this.SubscribeFlowDetails.merchantOperatorDisclaimer
              .cancelationShortCode,
          cancelKeyword:
            this.SubscribeFlowDetails.merchantOperatorDisclaimer
              .cancelationKeyword,
        }
      );
    },
    generalDisclaimerText() {
      //No need for $replacePlaceholders plugin function.
      return this.merchantConfig.texts.generalDisclaimer;
    },
  },
  components: {
    CardHeader,
    CustomStepper,
    PrimaryDisclaimer,
    Terms,
    HEInit,
    HEPincode,
    HESuccess,
    HEFailure,
    HEConfirmTrial,
    ExpiredSession
  },
  data() {
    return {
      steps: 2,
    };
  },
  methods: {
    ...mapMutations(['setSubscribeFlowDetails']),
  },
  async created() {
    this.$http.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        if (error.response.status === 401) {
          this.setSubscribeFlowDetails({
            step: 2,
            component: 'ExpiredSession',
            operationStatusCode: 401,
          });
        }
        return Promise.reject(error);
      }
    );

    let response = await this.$http.get(
      '/HeaderEnrichment/GetHeaderEnrichmentSubscriptionModel'
    );

    if (response.data.checkoutHeaderEnrichmentInfo.pinCodeVerification) {
      this.steps = 3;
    }

    this.setSubscribeFlowDetails({
      ...response.data,
      step: 1,
      component: 'HEInit',
      redirectUrl: response.data.subscriptionProductDetails.redirectUrl, // to be the same object structure as in sub flow
      initialProductName:
        response.data.subscriptionProductDetails.initialProductName, //solving success page issue.
      pinCodeVerification:
        response.data.checkoutHeaderEnrichmentInfo.pinCodeVerification,
      operatorCode: response.data.checkoutHeaderEnrichmentInfo.operatorCode,
    });
  },
};
</script>
